export const URI_MANAGER = (legalEntity: string) => `organization/legal-entity/${legalEntity}/manager`;
